class LanguageSelectorController {
  constructor(
    $q,
    $translate,
    TranslationService,
    LanguageService,
    StaffUserService,
    TaskQueueService,
    LogService
  ) {
    "ngInject";
    this.$q = $q;
    this.$translate = $translate;
    this.TranslationService = TranslationService;
    this.LanguageService = LanguageService;
    this.StaffUserService = StaffUserService;
    this.TaskQueueService = TaskQueueService;
    this.LogService = LogService;
    this._selectedLanguage = null;
  }

  $onInit() {
    const promises = [];
    promises.push(
      this.LanguageService.initialize()
        .then(() => {
          this.selectedLanguage = this.LanguageService.activeLanguage;
        })
    );
    return this.$q.all(promises);
  }

  get languages() {
    return this.LanguageService && this.LanguageService.languages;
  }

  set selectedLanguage(language) {
    this._selectedLanguage = language;
    const previouslyActiveLanguage = this.LanguageService.activeLanguage;
    if (language !== previouslyActiveLanguage) {
      this.LanguageService.setActiveLanguageWithLocale(language.locale)
        .then(language => {
          const staffUserId = this.StaffUserService.currentUserId;
          if (staffUserId) {
            const task = this.TaskQueueService.createTask('ChangeUserLanguageTask');
            task.staffUserId = staffUserId;
            task.locale = language.locale;
            this.TaskQueueService.executeOrEnqueue(task);
          } else {
            // User not logged in; change the language on next login
            this.StaffUserService.changeUserLanguageOnNextLogin(language.locale);
          }
        });
    }
  }

  get selectedLanguage() {
    return this.LanguageService && this.LanguageService.activeLanguage;
    // return this._selectedLanguage;
  }

  set cssClass(c) {
    this._cssClass = c;
  }

  get cssClass() {
    return this._cssClass;
  }
}

export default LanguageSelectorController;

